// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { NonSkuCaratWeightRangeFragmentDoc } from './nonSkuCaratWeightRange.fragment.generated';
import { NonSkuPriceRangeFragmentDoc } from './nonSkuPriceRange.fragment.generated';
import { StoneShapeFragmentDoc } from './stoneShape.fragment.generated';
import { StoneColorFragmentDoc } from '../../gems/fragments/StoneColor.fragment.generated';
export const NonSkuLabGrownDiamondBoundsFragmentDoc = gql`
    fragment nonSkuLabGrownDiamondBounds on NonSkuLabGrownDiamondsBounds {
  __typename
  caratWeight {
    ...nonSkuCaratWeightRange
  }
  price(currency: $currency, region: $region) {
    ...nonSkuPriceRange
  }
  shapes {
    ...stoneShape
  }
  colors {
    ...stoneColor
  }
}
    ${NonSkuCaratWeightRangeFragmentDoc}
${NonSkuPriceRangeFragmentDoc}
${StoneShapeFragmentDoc}
${StoneColorFragmentDoc}`;